import { Location } from '@angular/common';
import { Injectable, inject } from '@angular/core';

import { ConfigurationService } from '../configuration/configuration.service';

const PRIVATE_CLOUD_STORAGE_PREPROD = 'https://privatecloudstorage.imobi.mobicorp.ch';
const PRIVATE_CLOUD_STORAGE_PROD = 'https://privatecloudstorage.mobi.mobicorp.ch';

const PUBLIC_CLOUD_STORAGE_PREPROD = 'https://rwc-deliver-webcomp-b2c.app.mobiliar-preprod.ch';
const PUBLIC_CLOUD_STORAGE_PROD = 'https://rwc-deliver-webcomp-b2c.app.mobiliar.ch';

const PRIVATE_ACRONYM = 'b2e';

/**
 * Will create the correct URL to load webcomponents.
 * Taking into account if the SPA is OnPrem or Cloud and the stage its running in.
 * For Cloud SPAs the URL is not modified. Because the webcomponents are loaded from the rwc-deliver-server.
 */
@Injectable({ providedIn: 'root' })
export class WebcomponentURLService {
    #configurationService = inject(ConfigurationService);

    public getWebcomponentUrl(url: string): string {
        if (this.#configurationService.getSync('isCloudApp') && !this.#configurationService.isStage('local-dev')) {
            return url;
        } else {
            return this.getOnPremUrl(url);
        }
    }

    /**
     * Will return a WES Endpoint for B2E Webcomponents but will use a Cloud SPA
     * for B2C Webcomponents.
     *
     * @param url The path to the webcomponent.
     * @returns The URL under which the webcomponent is available to the calling SPA.
     */
    private getOnPremUrl(url: string): string {
        let baseURL;

        if (url.startsWith(`/ng-elements/${PRIVATE_ACRONYM}/`)) {
            if (this.isProd()) {
                baseURL = PRIVATE_CLOUD_STORAGE_PROD;
            } else {
                baseURL = PRIVATE_CLOUD_STORAGE_PREPROD;
            }
            return Location.joinWithSlash(
                baseURL,
                url.replace(new RegExp(`/ng-elements/${PRIVATE_ACRONYM}`), 'webcomponents')
            );
        } else {
            if (this.isProd()) {
                baseURL = PUBLIC_CLOUD_STORAGE_PROD;
            } else {
                baseURL = PUBLIC_CLOUD_STORAGE_PREPROD;
            }

            return Location.joinWithSlash(baseURL, url);
        }
    }

    isProd(): boolean {
        return this.#configurationService.isProduction();
    }
}
